import React, { Component } from 'react';
import { connect } from 'react-redux';
import QuoteText from '../Components/Quote/QuoteText.js';
import QuoteSlideshow from '../Components/Quote/QuoteSlideshow.js';
import timeHelpers from '../utils/timeHelpers.js';
import shared from '../utils/shared.js';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { getFileType, dp, videoType } from '../utils/shared';
import QuoteStory from '../Components/Quote/QuoteStory.js';
import _ from 'lodash';
import sailsIOClient from 'sails.io.js';
import socketIOClient from 'socket.io-client';
import cfg from '../../config.js'

const _videoStyle = {
  preload: 'auto',
  position: 'relative',
  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  loop: '',
  autoplay: "",
  muted: "",
  pointerEvents: "none"
}

const QUOTE = "image_quote";
const FULLSCREEN = "fullscreen_image";
const SLIDESHOW = "slideshow";
const SLIDESHOW_2 = "slideshow_2";
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class QuoteContainer extends Component {

  constructor(props) {
    super(props);
    
    try {
      this._elementStates = [];
      this._elementsIntervals = [];
      this._elementIntervalMS = null;
      this._checkerboardIndexStorage = null;
      this._assetFile = null;
      this._announcementAsset = null;
      this._announcementAudioAsset = null;
      this._announcementTimeout = null;
      this._modalCycle = null;
  
      this.setupElements();

      let currentTimeInterval = timeHelpers.elementIndexCurrentSeekTime(this._elementIntervalMS);

      let elementIndex = timeHelpers.indexFromIntervalArray(this._elementsIntervals);
      let timeIntervalRemainderMS = timeHelpers.timeIntervalRemainderArrayMS(this._elementsIntervals);
  
      this.state = {
        storyType: this._elementStates[elementIndex].bodyCopy.storyType,
        elementIndex: elementIndex,
        secondsPassed: 0,
        showDebug: 0,
        quoteState: 0,
        currentStage: 0,
        currentTimeInterval: currentTimeInterval,
        showOverlay: false,
        showModalVideo: false
      };
  
      this._currentVideoRef = null;
      this._intervalTimeoutMS = timeIntervalRemainderMS;
      this._intervalTimeout = null;
      this._intervalCommunityTimeout = null;
      this._intervalQuoteMS = 0;
      this._currentSlideshow = "quote_slideshow";
      this._intervalSeekTimeout = null;
      this._startTime = new Date();

      this._stages = 2;

    } catch(e) {
      console.log(e)
    }
  }

  websocketHandler = () => {
    let displayId = this.props.content.id;
    this._io = sailsIOClient(socketIOClient);

    this._io.sails.autoConnect = true;
    this._io.sails.url = cfg.WEB_SERVER;
    
    this._io.socket.on('email_announcement', (event) => {
      // console.log("Event triggered");
      this.setupAsset(event);
    });
    
    this._io.socket.on('connect', () => {
      this._io.socket.get(`/feed/subscribe?display=${displayId}`, function serverResponded(body, JWR) {
        // console.log('loaded');
      });
    });

    this._io.socket.on('error', (e) => {
      // console.log('error');
    });

    this._io.socket.on('disconnect', () => {
      this._io.socket._raw.io._reconnection = true;
    });
  }

  setupAsset = (event) => {
    let data = JSON.parse(event);
    if (data.subject && this.props.content.settings.announcement_modules) {
      let module = _.find(this.props.content.settings.announcement_modules, { subject: data.subject });
      if (module) {
        let announcementModule = _.find(this.props.content.dm_active, { id: module.id });
        if (announcementModule) {
          let asset = _.get(announcementModule.contents, "images[0]", null);
          if (asset) {
            this._assetFile = asset.file_name;
            let announcementAudioAsset = _.get(announcementModule.contents, "images[1]", null);
            if (announcementAudioAsset) {
              this._audioAssetFile = announcementAudioAsset.file_name;
            }
  
            this._announcementAsset = shared.dp(this.props.screen, asset);
            this._announcementAudioAsset = shared.dp(this.props.screen, announcementAudioAsset);
            this._announcementTimeout = Number(announcementModule.contents.timeout) * 1000;
            
            let timeout = 0;
            if (data.schedule_for) {
              timeout = (Number(data.schedule_for) - Date.now());
            }
            if (timeout <= 0) {
              this.showModal();
            } else {
              setTimeout(() => {
                this.showModal();
              },timeout);
            }
          }
        }
      }
    }
  }

  showModal() {
    let fileType = getFileType(this._assetFile);
    if (fileType === "video") {
      if (!this.state.showModalVideo) {
        this.setState({
          showModalVideo: true
        });
      }
    } else {
      if (!this.state.showModal) {
        this.setState({
          showModal: true
        });

        this._modalCycle = setTimeout(() => {
          this.setState({
            showModal: false
          });
        }, this._announcementTimeout);
      }
    }

    // Check for the audio asset
    if (this._audioAssetFile) {
      let audioFileType = getFileType(this._audioAssetFile);
      // console.log("2.- Filetype", audioFileType);
      if (audioFileType === "audio") {
        if (!this.state.playAudio) {
          this.setState({
            playAudio: true
          });
        }
      }
    }
  }

  closeModal() {
    let fileType = getFileType(this._announcementAsset);
    if (fileType === "video") {
      if (this.state.showModalVideo) {
        this.setState({
          showModalVideo: false
        });
        clearTimeout(this._modalCycle);
      }
    } else {
      if (this.state.showModal) {
        this.setState({
          showModal: false
        });
        clearTimeout(this._modalCycle);
      }
    }
  }

  setupElements() {
    try {
      let count = 0;
      let rootFolder = _.get(this.props.content, 'settings.selected_root_folder', null);
      let parentActive = {}
      if (rootFolder !== null) {
        rootFolder = Number(rootFolder);
        parentActive = _.find(this.props.content.story_categories, { id: rootFolder} );
      } else {
        parentActive = _.find(this.props.content.story_categories, (folder) => {
          let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
          return type === "active";
        });
      }
      let storyBoardFolder = _.find(this.props.content.story_categories, (folder) => {
        let type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
        return (type === 'attract_loop_stories' && folder.parent_category === parentActive.id);
      });
      let modules = shared.getAllFolderModules(this.props.content.folder_modules, this.props.donors, this.props.content.stories, storyBoardFolder.id);

      if (modules && modules.length > 0) {
        _.forEach(modules, (module, key) => {
          let section = (count === 0 || (count % 2 === 0)) ? "right" : "left";
          let fileObj = _.get(module, 'contents.images[1]', null);
          let backgroundMedia = dp(this.props.screen, _.get(module, 'contents.images[1]', null));
          let backgroundType = fileObj ? getFileType(fileObj.file_name) : "unspported";

          let storyType = _.get(module.contents.custom_fields, "story_type.val.value", QUOTE);
          let overlay = storyType === FULLSCREEN ? false : true;

          let cycleTime = Number(_.get(module.contents.custom_fields, 'cycle_time.val', 60));
          let quoteCycleTime = Number(_.get(module.contents.custom_fields, 'cycle_time.val', 20));
          cycleTime *= 1000;
          quoteCycleTime *= 1000;

          let upperTextVal = _.get(module.contents, "custom_fields.long_quote_text.val", "")
          let lowerTextVal = _.get(module.contents, "custom_fields.long_quote_text_part_2.val", "")
          let signatureVal = _.get(module.contents, "custom_fields.signature.val", "")

          let upperText = "";
          let lowerText = "";
          let signatureText = "";
          let converter = {}
          
          if (upperTextVal.ops) {
            converter = new QuillDeltaToHtmlConverter(upperTextVal.ops, {});
            upperText = converter.convert();
          }
          if (lowerTextVal.ops) {
            converter = new QuillDeltaToHtmlConverter(lowerTextVal.ops, {});
            lowerText = converter.convert();
          }

          if (signatureVal.ops) {
            converter = new QuillDeltaToHtmlConverter(signatureVal.ops, {});
            signatureText = converter.convert();
          }

          let quote = [{
            upperText: upperText,
            lowerText: lowerText,
            signatureText: signatureText
          }, {
            upperText: upperText,
            lowerText: lowerText,
            signatureText: signatureText
          }, {
            upperText: upperText,
            lowerText: lowerText,
            signatureText: signatureText
          }];

          this._elementsIntervals.push(cycleTime);
          this._elementStates.push({
            quotes: quote,
            cycleTime: cycleTime,
            quoteCycleTime: quoteCycleTime,
            customFields: module.contents.custom_fields,
            arrays: _.get(module.contents, 'arrays', {}),
            arraysValues: _.get(module.contents, 'arrays_values', {}),
            backgroundImageDonorSea: backgroundMedia,
            backgroundType: backgroundType,
            overlayText: overlay,
            quoteOverlayOffsetDuration: 2,
            bodyCopy: {
              storyType: storyType,
              marginLeft: 5,
              marginRight: 30,
              upperText: module.contents.story,
              lowerText: _.has(module.contents, "custom_fields.long_quote_part_2.val") ? module.contents.custom_fields.long_quote_part_2.val : "",
              longQuoteStyle: _.has(module.contents, "custom_fields.long_quote_style") ? module.contents.custom_fields.long_quote_style : "",
              longQuoteCenterOffset: _.get(module.contents, "custom_fields.long_quote_center_offset.val", 5),
              shortQuoteStyle: _.has(module.contents, "custom_fields.short_quote_style") ? module.contents.custom_fields.short_quote_style : "",
              signature: _.has(module.contents, "custom_fields.signature") ? module.contents.custom_fields.signature.val : "",
              signatureStyle: _.has(module.contents, "custom_fields.signature_style") ? module.contents.custom_fields.signature_style : "",
              section: section,
              quoteBackdrop: _.get(module.contents.custom_fields, "long_quote_background_color.val", "#FFFFFF")
            }
          });

          if (storyType === QUOTE) {
            count++;
          }
        })
      } else {
        console.log("No modules were found in the attract loop");
      }
    } catch(e) {
      console.log(e);
    }

    // console.log(this._elementStates);
  }

  componentDidMount() {
    try {
      let socketsEnabled = _.get(cfg, 'sockets.enabled', false);
      if (socketsEnabled) {
        this.websocketHandler();
      }
      this.setupIntervalHandler();
      this.setupQuoteIndexHandler(); //rework to use the element index instead, becoase video will cycle with quotes.
      document.addEventListener("keydown", this.handleKeyDown);
    } catch(e) {
      console.log(e);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this._intervalTimeout);
    clearTimeout(this._intervalSeekTimeout);
    this._intervalTimeout = null;
    this._intervalSeekTimeout = null;
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "d":
        let newDebug = this.state.showDebug + 1
        if (newDebug > 2) {
          newDebug = 0
        }
        this.setState({
          showDebug: newDebug
        })
        break;
      default:
        break;
    }
  }

  setupIntervalHandler = () => {
    // console.log('interval');
    clearTimeout(this._intervalTimeout);
    this._intervalTimeout = null;
    this._intervalTimeout = setTimeout(() => {
      this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._elementsIntervals);

      if (this._intervalTimeoutMS > 500) {
        let elementIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");
        // console.log("current stage index", this.state.currentStage);
        // let stageIndex = shared.loopIndex(this.state.currentStage, 0, this._stages, "forward");
        // console.log("new stage index", stageIndex);
        let currentStoryType = this._elementStates[elementIndex].bodyCopy.storyType;
  
        this.setState({
          elementIndex: elementIndex,
          storyType: currentStoryType,
          // currentStage: stageIndex
        });
      }

      this.setupIntervalHandler();
    }, this._intervalTimeoutMS);
  }

  setupQuoteIndexHandler = () => {
    clearTimeout(this._quoteIndexTimeout);
    this._quoteIndexTimeout = null;
    this._quoteIndexTimeout = setTimeout(() => {
      // let quotes = this._elementStates[this.state.elementIndex].quotes;
      let quotesLength = 1;
      
      // These times are for the whole slide cycle.
      let timeIntervalRemainderMS = timeHelpers.timeIntervalRemainderArrayMS(this._elementsIntervals);
      if (this.props.debug) {
        console.log("Time Interval Remainder", timeIntervalRemainderMS);
      }
      let elementIntervalMS = this._elementStates[this.state.elementIndex].cycleTime;
      if (this.props.debug) {
        console.log("elementIntervalMs", elementIntervalMS);
      }
      let currentMoment = elementIntervalMS - timeIntervalRemainderMS;
      if (this.props.debug) {
        console.log("currentMoment", currentMoment);
      }
      let quoteOverlayOffsetDuration = this._elementStates[this.state.elementIndex].quoteOverlayOffsetDuration * 1000;

      // Check current quote index based on duration of each of the quotes.
      // These times are for the Quote Cycle (Could be multiple quotes per Slide Cycle)
      // let quoteCycleTime = this._elementStates[this.state.elementIndex].quoteCycleTime;
      let quoteCycleTime = elementIntervalMS;
      let currentMomentInQuoteTransitionMS = currentMoment % quoteCycleTime;
      let timeQuoteRemainderMS = quoteCycleTime - currentMomentInQuoteTransitionMS;
      let currentQuoteIndex = Math.floor(currentMoment / quoteCycleTime) % quotesLength;
      if (this.props.debug) {
        console.log("Current Quote Index", currentQuoteIndex);
      }
      if ((currentQuoteIndex + 1) > quotesLength) {
        currentQuoteIndex = 0;
      }

      let nextIndex = this.state.elementIndex;
      if (this.props.debug) {
        console.log("Next Index", nextIndex);
      }

      if (timeIntervalRemainderMS > 500) {
        if (this.props.debug) {
          console.log("Time Interval is > than 500");
        }

        if (timeIntervalRemainderMS <= timeQuoteRemainderMS - quoteOverlayOffsetDuration) {
          nextIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");
        }
  
        if (this._elementStates[this.state.elementIndex].overlayText) {
          // Show when the video is starting
          // console.log("Has Overlay")
          if (currentMomentInQuoteTransitionMS >= quoteOverlayOffsetDuration && currentMomentInQuoteTransitionMS < (quoteCycleTime - quoteOverlayOffsetDuration)) {
            if (this.props.debug) {
              console.log("Show the Quote", currentQuoteIndex, "for element", nextIndex);
            }

            this._intervalQuoteMS = timeQuoteRemainderMS - quoteOverlayOffsetDuration;
            this.setState({
              showOverlay: true,
              currentQuoteIndex: currentQuoteIndex
            });
            // Hide when the video is ending
          } else if (currentMomentInQuoteTransitionMS >= (quoteCycleTime - quoteOverlayOffsetDuration)) {
            // console.log('hiding at', currentMoment);
            if (this.props.debug) {
              console.log("Hide the Quote", currentQuoteIndex, "for element", nextIndex);
            }
            this._intervalQuoteMS = timeQuoteRemainderMS + (this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000);
            this.setState({
              showOverlay: false,
              currentQuoteIndex: currentQuoteIndex
            });
          } else {
            this._intervalQuoteMS = 100;
            if (this.props.debug) {
              console.log("None of the previous conditions were met, delay next interval 100ms");
            }
          }
        } else {
          this.setState({
            showOverlay: false,
            currentQuoteIndex: currentQuoteIndex
          });
          this._intervalQuoteMS = timeIntervalRemainderMS + (this._elementStates[nextIndex].quoteOverlayOffsetDuration * 1000);
        }
      } else {
        if (this.props.debug) {
          console.log("Time Interval is not > than 500");
        }
      }

      this.setupQuoteIndexHandler();
    }, this._intervalQuoteMS);
  }

  setVideoSeekTimeInterval = () => {
    clearTimeout(this._intervalSeekTimeout);
    this._intervalSeekTimeout = null;
    this._intervalSeekTimeout = setTimeout(() => {
      let fileType = getFileType(this._elementStates[this.state.elementIndex].backgroundImageDonorSea);
      if (fileType === "video") {
        if (!this._currentVideoRef) {
          this.setVideoSeekTimeInterval();
        } else {
          this._currentVideoRef.currentTime = (this.state.currentTimeInterval / 1000);
          clearTimeout(this._intervalSeekTimeout);
        }
      }
    }, 30);
  }

  loadedMetadata = (event) => {
    let videoHeight = this._videoModalRef.getBoundingClientRect().height;
    let videoWidth = this._videoModalRef.getBoundingClientRect().width;
    let videoMaxHeight = 0;
    let videoMaxWidth = 0;
    let videoOffsetX = 0;
    let videoOffsetY = 0;
    let videoRatio = videoWidth / videoHeight;
    // let screenRatio = this.props.screen.screenWidth / this.props.screen.screenHeight;
    let isHorizontal = videoWidth > videoHeight;

    if (isHorizontal) {
      videoMaxWidth = this.props.screen.screenWidth;
      videoMaxHeight = videoMaxWidth / videoRatio;
    } else {
      videoMaxHeight = this.props.screen.screenHeight;
      videoMaxWidth = videoMaxHeight * videoRatio;
    }

    videoOffsetX = (videoMaxWidth < this.props.screen.screenWidth) ? (this.props.screen.screenWidth / 2) - (videoMaxWidth / 2) : 0;
    videoOffsetY = (videoMaxHeight < this.props.screen.screenHeight) ? (this.props.screen.screenHeight / 2) - (videoMaxHeight / 2) : 0;

    let videoControlsOffset = videoOffsetY + (videoHeight / 2);

    // console.log("Loaded Metadata");

    if (this._videoModalRef !== undefined && this._videoModalRef !== null) {
      let duration = this._videoModalRef.duration;
      // console.log("1- Setting a duration of", duration);
      this._modalCycle = setTimeout(() => {
        // console.log("Closing Modal");
        this.setState({
          showModalVideo: false
        });
      }, duration * 1000);
    } else {
      this.handleVideoDuration();
    }    

    this.setState({
      duration: event.target.duration,
      videoOffsetY: videoOffsetY,
      videoOffsetX: videoOffsetX,
      videoControlsOffset: videoControlsOffset,
      videoMaxHeight: videoMaxHeight,
      videoMaxWidth: videoMaxWidth,
      videoFile: this.props.content.file_path
    });
  }

  render() {
    const modalStyle = {
      position: 'absolute',
      height: this.props.screen.screenHeight,
      width: this.props.screen.screenWidth,
      // backgroundColor:'#a4bcc2',
      zIndex: 9999
    }

    const _btnStyle = {
      color: 'white',
      position:'absolute',
      fontSize: this.props.screen.screenHeight * 0.05,
      fontStyle:'normal',
      fontWeight: 'bold',
      textDecoration:'none',
      zIndex:9999
  }

    let cType = "";
    if (this.state.showModalVideo) {
      cType = videoType(this._announcementAsset);
    }
    try {
      return (
        <div style={{ backgroundColor:"white", fontFamily: 'Roboto', position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>          
          {/* STORIES TRANSITIONS */}
          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.elementIndex}>  
              {/* STORY WITH QUOTE */}
              {
                this.state.storyType === QUOTE ?
                  <QuoteStory
                    element={this._elementStates[this.state.elementIndex]}
                    horizontalScreens={3}
                    verticalScreens={2}
                    screen={this.props.screen}
                  />
                  : null
              }
              {/* STORY WITH FULLSCREEN IMAGE */}
              {
                this.state.storyType === FULLSCREEN ?
                  <QuoteStory
                    element={this._elementStates[this.state.elementIndex]}
                    horizontalScreens={3}
                    verticalScreens={2}
                    screen={this.props.screen}
                    fullscreen={true}
                  />
                  : null
              }
  
              {/* STORY WITH PUZZLE CHECKERBOARD */}
              {
                [SLIDESHOW, SLIDESHOW_2].indexOf(this.state.storyType) > -1 ?
                  <QuoteSlideshow
                    element={this._elementStates[this.state.elementIndex]}
                    xScreens={3}
                    yScreens={2}
                  />
                  : null
              }
  
            </div>
            <div key={this.state.showModal}>
              {
                this.state.showModal ?
                  <div style={{ ...modalStyle }}>
                    <a href="#" onClick={() => { this.closeModal() }} ref={el => this._closeModalRef = el} style={{ ..._btnStyle, top: this.state.closeModalBtnOffsetY, left: this.state.closeModalBtnOffsetX }}>X</a>
                    <img alt={"Announcement Modal"} style={{ position: 'absolute' }} src={this._announcementAsset} ref={el => this._imageModalRef = el} onLoad={this.handleImageLoaded.bind(this)} />
                  </div>
                  : null
              }
            </div>
            <div key={this.state.showModalVideo}>
              {
                this.state.showModalVideo ?
                  <div style={{ ...modalStyle, backgroundColor: "black" }}>
                    <video style={{ ..._videoStyle, top: this.state.videoOffsetY, left: this.state.videoOffsetX }} ref={el => this._videoModalRef = el} onLoadedMetadata={this.loadedMetadata.bind(this)} autoPlay muted>
                      <source src={this._announcementAsset} type={cType} />
                      Your browser does not support the video tag.
                  </video>
                  </div>
                  : null
              }
            </div>
          </CSSTransitionGroup>
          
          {/* TEXT OVERLAY */}
          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showOverlay}> 
              {
                this.state.showOverlay && this.state.storyType === QUOTE ?
                  <QuoteText
                    elementIndex={this.state.elementIndex}
                    upperText={this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex].upperText}
                    lowerText={this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex].lowerText}
                    signature={this._elementStates[this.state.elementIndex].quotes[this.state.currentQuoteIndex].signatureText}
                    sections={3}
                    screenWidth={this.props.screen.screenWidth}
                    screenHeight={this.props.screen.screenHeight}
                    bodyCopy={this._elementStates[this.state.elementIndex].bodyCopy}
                    xScreens={3}
                    yScreens={2}
                  />
                  :
                  null
              }
            </div>
          </CSSTransitionGroup>

          {/* <div style={{ position: "absolute", height: this.props.screen.screenHeight, width: this.props.screen.screenWidth, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ font: "bold", fontSize: "50vh", opacity:0.5 }}>{this.state.currentStage}</span>
            <span style={{ font: "bold", fontSize: "20vh", opacity: 0.5 }}> - NO TRANSITIONS</span>
          </div> */}
        </div>
      );
    } catch(e) {
      console.log(e);
    }
  }
}

const mapStateToProps = (state) => {
  let debug = shared.parseStringParam(window.location.href, "debug");
  if (debug === undefined || debug === null) {
    debug = false;
  }
  return {
    screen: state.screen,
    content: state.content,
    donors: state.donors,
    debug: debug
  };
};

export default connect(mapStateToProps)(QuoteContainer);



// WEBPACK FOOTER //
// ./src/containers/QuoteContainer.js